import {action, computed, _, runInAction} from '@api'
import {SYNC_DEV_HIERARCHY, SYNC_PLAN} from '@api/graphql'
import {observable} from 'mobx'
import {VLPHierarchyStore} from './VLPHierarchyStore'
import {CatalogStore} from '@stores'
import {placeholderImages, placeholderPDFImages} from './placeholders'

export const DEBUG_VLP = DEBUG && false

export class VLPStore {
  constructor(public catalog: CatalogStore) {
    this.hierarchy = new VLPHierarchyStore(catalog)
  }

  @computed get hierarchyPath() {
    return ['plan', 'subCategories', 'collection', 'collectionVersion']
  }

  @action dispose = () => {
    this.hierarchy?.dispose()
  }

  hierarchy: VLPHierarchyStore

  @action onClickRefreshSeason = async () => {
    this.isRefreshingSeasons = !this.isRefreshingSeasons
    const {catalog: {dialogs, onError, stores: {apollo: {client}, deployments: {deploymentConfig: {syncDevHierarchy}}, vlp: {hierarchy: {loadPlansES, setPlanHierarchy}}, workspaces: {workspaceConfig}}}} = this
    try {
      // TODO: will remove to sync dev hierarchy on refresh once implemented with C8 load
      syncDevHierarchy && await client.mutate({mutation: SYNC_DEV_HIERARCHY})

      // Refetch plan
      if (workspaceConfig && workspaceConfig?.breadcrumbSource !== 'c8') {
        await client.mutate({mutation: SYNC_PLAN});
        await setPlanHierarchy(await loadPlansES())
      }
      runInAction(() => {
        this.hierarchy.hasLoadedHierarchy = true
        _.assign(dialogs.snackbar, {show: true, message: 'Merchandising Board is refreshed successfully.'})
      })
    } catch (err) {
      onError(err)
      // site.showSnackbar = true
      // site.message = 'unable to refresh user information'
    } finally {
      this.isRefreshingSeasons = false
    }
  }

  @observable isRefreshingSeasons = false

  @action vlpProductFieldfor(spec) {
    switch (spec) {
      case 'vlpProduct':
      case 'vlpProduct_old':
        return 'merchOptionVersions'
      case 'vlpSecondaries':
        return 'options'
      case 'tag':
      case 'tags':
        return 'merchOptionVersionTagListCustomAttribute'
      default:
        return ''
    }
  }

  @observable.ref refetchVlpCounts

  @computed get isVLPView() {
    const {catalog: {workspaces}} = this
    return (workspaces.workspaceConfig?.view === 'catalog' || workspaces.workspaceConfig?.catalog != null)// && (catalog.seasonSelectorFields ?? []).some(f => f.field === 'plan')
  }

  @action reset = () => {
    //this.hierarchy.reset()

    this.hierarchy.selected.plans = null
    this.hierarchy.selected.folders = null
    this.hierarchy.selected.collections = null
  }

  @computed get placeholderImg(): string {
    const {catalog, isVLPView, hierarchy: {selectedFolders}} = this

    const result = !isVLPView
                   ? null
                   : selectedFolders.map(f =>
          catalog.isShowingClientPDF ? placeholderPDFImages[_.toUpper(f.name)]
                                     : placeholderImages[_.toUpper(f.name)]
        ).find(_.identity)

    return result
  }

  placeholderImgFor = (thing) => {
    const {catalog, placeholderImg} = this

    return !_.isArray(thing?.subCategories)
           ? placeholderImg
           : (thing?.subCategories?.map(
      ({name}) => {
        return catalog.isShowingClientPDF
               ? placeholderPDFImages[_.toUpper(name)]
               : placeholderImages[_.toUpper(name)]
      }) || []).find(_.identity) || placeholderImg
  }

  isVLPField = (type: string) => {
    const {catalog: {hasMerch}} = this
    return hasMerch && (type === 'plan' || type === 'folder' || type === 'collection')
  }
}



// WEBPACK FOOTER //
// ./src/stores/vlp/store/VLPStore.ts